// Emit provider artwork through the existing website image asset pipeline.
require('../images/provider-branding/provider-badge-automait.v1.svg');
require('../images/provider-branding/provider-badge-autocx.v1.svg');
require('../images/provider-branding/provider-badge-autocx.v2.svg');
require('../images/provider-branding/provider-badge-vert.v1.svg');
